import React from 'react';
import { translate } from 'react-i18next';
import { TranslationFunction } from 'i18next';
import { Button } from 'reactstrap';
import './alertPopup.scss';

interface IProps {
  align?: string | null;
  t: TranslationFunction;
}

const AlertPopup = ({ align, t }: IProps) => {
  const classes = 
    align ? `customers-header__banner-btn ${ align }` : 'customers-header__banner-btn';

  return (
    <div className="customers-header__alert-banner">
      <p className="customers-header__banner-content">
        { t('Banners:alertBanner') }
      </p>

      <div className={ classes }>
        <Button
          onClick={ () => {
            window.open('https://pro.mylight150.com/', '_blank');
          } }
        >
          { t('Banners:goToConstellationAppBtn') }
        </Button>

        <Button
          onClick={ () => {
            window.open(
              'https://www.mylight150.com/articles/fermeture-aux-nouveaux-clients-sur-la-regie-strasbourg-electricite-reseau-ce-que-vous-devez-savoir',
              '_blank'
            );
          } }
        >
          { t('Banners:learnMoreBtn') }
        </Button>
      </div>
    </div>
  );
};

export default translate(['Common', 'Banners'])(
  AlertPopup
);